import {
  COMPARE_PAGE_ALTER_PLANS,
  COMPARE_PAGE_RESET_PLANS,
} from './actionTypes';

export default function reducer(state = [], action) {
  switch (action.type) {
    case COMPARE_PAGE_ALTER_PLANS:
      return [
        ...state,
        action.planId,
      ];
    case COMPARE_PAGE_RESET_PLANS:
      return [];
    default: return state;
  }
}

// actions
export function alterPlansInComaparePage(planId) {
  return {
    type: COMPARE_PAGE_ALTER_PLANS,
    planId,
  };
}

export function resetPlansInComparePage() {
  return {
    type: COMPARE_PAGE_RESET_PLANS,
  };
}
